import TabPage from "./../factories/tab-page";
import "./../bindings/bao-number-box";
import "./../bindings/bao-toolbar2";
import BaseViewModel from "./../factories/base-view-model2";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import TabController from "./../factories/tab-controller";
import BaoDialog from "./../factories/bao-dialog";
class BillingFolder extends BaseViewModel {
    Name = ko.observable();
    Years: KnockoutObservableArray<number> = ko.observableArray([]);
    Months: KnockoutObservableArray<number> = ko.observableArray([]);
    Year: KnockoutObservable<number | string> = ko.observable(null);
    Month: KnockoutObservable<number | string> = ko.observable(null);
    public BillingTab: TabPage;
    public constructor(tabPage: TabPage) {
        super(tabPage);
    }
    public CompleteCheck(): JQueryPromise<boolean> | boolean {
        var completed: boolean;
        completed = true;
        if (this.Name() === "" || this.Name() === null || this.Year() === "" || this.Month() === "") {
            completed = false;
        }
        if (!completed) {
            var baoDialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return completed;
    }
    public InitUrl(): string {
        return "BillingFolder/Init";
    }
    public initTabs() {
        return super.InitTabController().then(() => {
            this.BillingTab = new TabPage();
            this.BillingTab.IsClosable(false);
            this.BillingTab.AutoSelect = true;
            this.BillingTab.Url("BillingTab");
            this.TabController.AddTab(this.BillingTab);
        });
    }
    public init(): JQueryPromise<void> {
        let def = $.Deferred<void>();
        $.when(super.init(), this.initTabs()).then(() => {
            return Bao.post("BillingFolder/BillingFolderGetDefaultData", (result) => {
                ko.map.fromJS(result, this);
                def.resolve();
            });
        });
        return def.promise();
    }
}
export default BillingFolder;